import React, { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function LitigeProtocol({ sav, opts, onSent }) {
  const c = sav.client || {};
  const [f, setF] = useState({ protocol: "protocole_cas_par_cas", first_name: c.prenom || "", last_name: c.nom || "", email: c.email || "", phone: c.telephone || "" });
  const [sigs, setSigs] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/dossiers/${sav.dossier_id}/signatures`).then((r) => setSigs((r.data.items || r.data || []).filter((s) => s.litige_id === sav.id))).catch(() => {});
  useEffect(() => { load(); }, [sav.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try { await api.post(`/litiges/${sav.id}/protocole`, f); toast.success("Protocole envoyé en signature (Yousign)"); load(); onSent(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Envoi impossible"); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="space-y-3" data-testid="litige-protocol">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
        <select className="input-field md:col-span-2" value={f.protocol} onChange={set("protocol")} data-testid="litige-protocol-type">
          {(opts?.protocols || []).map((p) => <option key={p.id} value={p.id}>{p.label}</option>)}</select>
        <input className="input-field" placeholder="Prénom" value={f.first_name} onChange={set("first_name")} data-testid="litige-protocol-first" />
        <input className="input-field" placeholder="Nom" value={f.last_name} onChange={set("last_name")} data-testid="litige-protocol-last" />
        <input className="input-field" placeholder="Email" value={f.email} onChange={set("email")} data-testid="litige-protocol-email" />
      </div>
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] text-norea-textMuted">Modèles provisoires (le modèle Word de Norea se dépose dans Configuration → Litiges & protocoles). Signature en environnement Yousign configuré (sandbox).</span>
        <button onClick={send} disabled={busy} className="btn-primary text-xs inline-flex items-center gap-1.5" data-testid="litige-protocol-send">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}Envoyer en signature</button>
      </div>
      {sigs.length > 0 && <div className="text-xs space-y-1" data-testid="litige-protocol-list">
        {sigs.map((s) => <div key={s.id} className="flex justify-between border-t border-norea-border pt-1"><span>{s.doc_name} — {s.signer?.email}</span><b>{s.status_label}</b></div>)}</div>}
    </div>
  );
}
